import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const CitizenFarDetails = ({ formData }) => {
  const { t } = useTranslation();
  const properties = formData?.descriptionOfLand?.properties?.[0];
  const factorString = properties?.landUseAsPerLayout;
  console.log("DetailsFromFAR", formData);

  const factorNum = React.useMemo(() => {
    if (factorString === "Residential (Group Housing)" || factorString === "Hotel") {
      return 0.4;
    } else if (factorString === "Office/Organization" || factorString === "Mixed land") {
      return 0.45;
    } else if (factorString === "Commercial") {
      return 0.5;
    } else {
      return 0.2;
    }
  }, [factorString]);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
      properties: [{ ...formData?.descriptionOfLand?.properties?.[0] }],
    },
  };

  return (
    <Table bordered className="m-0">
      <thead className="table-header">
        <tr>
          <th style={{ minWidth: "fit-content" }}>Field Name</th>
          <th style={{ minWidth: "fit-content" }}>Input Data</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>{t("Required FAR")}</b>
          </td>
          <td>{properties?.percentRequiredFAR}</td>
        </tr>
        <tr>
          <td>
            <b>{t("Required FAR Area")}</b>
          </td>
          <td>{properties?.requiredAreaFAR}</td>
        </tr>
        {formData?.taxHeadEstimates?.[0]?.basicFar && (
          <tr>
            <td>
              <b>{t("Basic FAR and Area (SqM)")}</b>
            </td>
            <td>{`${formData?.taxHeadEstimates?.[0]?.basicFar} and ${formData?.taxHeadEstimates?.[0]?.totalBuiltUpArea}`}</td>
          </tr>
        )}

        {formData?.taxHeadEstimates?.[0]?.permissibleFAR && (
          <tr>
            <td>
              <b>{t("Permissible Purchasable FAR and Area (SqM)")}</b>
            </td>
            <td>{`${formData?.taxHeadEstimates?.[0]?.permissibleFAR} and ${formData?.taxHeadEstimates?.[0]?.permissibleFARArea}`}</td>
          </tr>
        )}

        {formData?.taxHeadEstimates?.[0]?.totalPermissibleFar && (
          <tr>
            <td>
              <b>{t("Maximum Permissible Purchasable FAR and Area (SqM)")}</b>
            </td>
            <td>{`${formData?.taxHeadEstimates?.[0]?.totalPermissibleFar} and ${formData?.taxHeadEstimates?.[0]?.totalPermissibleFARArea}`}</td>
          </tr>
        )}
        <tr>
          <td>
            <b>{t("Factor")}</b>
          </td>
          <td>{formData?.taxHeadEstimates?.[0]?.factor}</td>
        </tr>
        {!!formData?.taxHeadEstimates?.[0]?.schemeRate && (
          <tr>
            <td>
              <b>{t("Circle Rate")}</b>
            </td>
            <td>{formData?.taxHeadEstimates?.[0]?.schemeRate}</td>
          </tr>
        )}
        {Boolean(formData?.taxHeadEstimates?.[0]?.estimateAmount) && (
          <tr>
            <td>
              <b>{t("Total fees")}</b>
            </td>
            <td>{formData?.taxHeadEstimates?.[0]?.estimateAmount}</td>
          </tr>
        )}
      </tbody>
      {/* {!Boolean(formData?.taxHeadEstimates?.[0]?.estimateAmount) && (
        <span style={{ margin: "18px auto", padding: "4px" }}>Fees will be generated only after application is approved.</span>
      )} */}
    </Table>
  );
};

export default CitizenFarDetails;
